// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__yyuMd","addWidgetButton":"Header_addWidgetButton__2bTPl","dashboardTabs":"Header_dashboardTabs__lqenI","active":"Header_active__2hdxf"};